import * as React from 'react';
// import { useAuth } from '@/hooks/useAuth'; // Removed useAuth
import { useWeb3Auth } from '@/providers/Web3AuthProvider';
import { Navigate, Outlet, useLocation } from 'react-router-dom'; // Removed useNavigate
import { PageLoader } from '@/components/ui/loader';

export function AdminProtectedRoute() {
	// const { isAdmin, isLoading: authLoading, user } = useAuth(); // Removed useAuth variables
	const {
		isLoggedIn,
		isWeb3AuthLoading,
		authAttemptCompleted, // Added authAttemptCompleted
	} = useWeb3Auth();
	const location = useLocation();
	// const navigate = useNavigate(); // Removed useNavigate as Navigate component is used
	// const [forcedRedirect, setForcedRedirect] = React.useState(false); // Removed
	// const [initialLoadComplete, setInitialLoadComplete] = React.useState(false); // Removed

	// Removed useEffect for initialLoadComplete timer

	// const isLoading = authLoading || isWeb3AuthLoading; // Simplified to just isWeb3AuthLoading or derived from authAttemptCompleted

	// Removed useEffect for the loading timeout

	// If Web3Auth is still loading and the initial auth attempt hasn't completed, show a loader.
	// This covers the period when Web3AuthProvider is trying to determine the auth state,
	// especially after a hard refresh.
	if (isWeb3AuthLoading && !authAttemptCompleted) {
		console.log(
			'AdminProtectedRoute: Web3Auth is loading and auth attempt not yet completed. Showing loader.',
			{ isWeb3AuthLoading, authAttemptCompleted }
		);
		return <PageLoader message='Authenticating...' />;
	}

	// If the authentication attempt has completed:
	if (authAttemptCompleted) {
		if (!isLoggedIn) {
			// Auth attempt is complete, but user is not logged in.
			console.log(
				'AdminProtectedRoute: Auth attempt completed, user NOT logged in. Redirecting to home.',
				{
					isLoggedIn,
					authAttemptCompleted,
					currentPath: location.pathname,
				}
			);
			return <Navigate to='/' state={{ from: location }} replace />;
		}
		// Auth attempt is complete and user is logged in.
		console.log(
			'AdminProtectedRoute: Auth attempt completed, user IS logged in. Rendering Outlet.',
			{ isLoggedIn, authAttemptCompleted }
		);
		return <Outlet />;
	}

	// Fallback case: If authAttemptCompleted is somehow false, but isWeb3AuthLoading is also false.
	// This state should ideally not be reached if Web3AuthProvider logic is correct.
	// Shows a loader as a safe default, or could redirect.
	console.log(
		'AdminProtectedRoute: Fallback - authAttemptCompleted is false, isWeb3AuthLoading is false. Showing loader.',
		{ isWeb3AuthLoading, authAttemptCompleted, isLoggedIn }
	);
	return <PageLoader message='VERIFYING...' />;
}
